// extracted by mini-css-extract-plugin
export default {"copyright_paragraph":"Copyright_copyright_paragraph__xhlcX"};